export default __webpack_public_path__ + "static/media/illustration-infrastructure-network.f9c41a27.svg";